import React from 'react';
import { createGlobalStyle } from 'styled-components';

import useShowMobileAppPrompt from './useShowMobileAppPrompt';

const HideModalPortals = createGlobalStyle`
  #glints-portal-container [data-testid='modal-wrapper'] {
    display: none;
  }
`;

export default function HideModalsOnMobileAppPrompt() {
  const isPromptVisible = useShowMobileAppPrompt();

  if (!isPromptVisible) {
    return null;
  }

  return <HideModalPortals />;
}
